import React from 'react';

const TailwindSVG = () => {
  return (
    <svg width="63" height="63" viewBox="0 0 63 63" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="31.125" cy="31.875" r="31.125" fill="#C9E4DE"/>
      <g clipPath="url(#clip0_0_1)">
      <path d="M30.3762 21.75C25.4762 21.75 22.4137 24 21.1887 28.5C23.0262 26.25 25.17 25.4063 27.62 25.9688C29.018 26.2894 30.0164 27.2203 31.1235 28.2525C32.9258 29.9316 35.0098 31.875 39.5637 31.875C44.4637 31.875 47.5262 29.625 48.7512 25.125C46.9137 27.375 44.77 28.2188 42.32 27.6562C40.9219 27.3356 39.9236 26.4047 38.8165 25.3725C37.0157 23.6934 34.9317 21.75 30.3762 21.75ZM21.1887 31.875C16.2887 31.875 13.2262 34.125 12.0012 38.625C13.8387 36.375 15.9825 35.5313 18.4325 36.0938C19.8305 36.4144 20.8289 37.3453 21.936 38.3775C23.7383 40.0566 25.8223 42 30.3762 42C35.2762 42 38.3387 39.75 39.5637 35.25C37.7262 37.5 35.5825 38.3438 33.1325 37.7813C31.7344 37.4606 30.7361 36.5297 29.629 35.4975C27.8282 33.8184 25.7442 31.875 21.1887 31.875Z" fill="#06B6D4"/>
      </g>
      <defs>
      <clipPath id="clip0_0_1">
      <rect width="36.75" height="33.75" fill="white" transform="translate(11.9998 15)"/>
      </clipPath>
      </defs>
    </svg>
  )
}

export default TailwindSVG;